import { gql } from '@apollo/client';
import {
  apiResponseFragment,
  fieldOptionListValueFragment,
  sectionedFieldOptionListValuesFragment,
  textPairFragment,
} from '../../query/fragments';

export const marketingPrefsFormTextQuery = gql`
  query MarketingPreferencesText {
    textFor {
      cancel: pair(pairKey: "cancel") {...textPair}
      legalLinks: pair(pairKey: "marketingPrefsLegalLinks") {...textPair}
      marketingPrefsPreloadError: pair(pairKey: "marketingPrefsPreloadError") {...textPair}
      pleaseTryAgain: pair(pairKey: "pleaseTryAgain") {...textPair}      
      processing: pair(pairKey: "processing") {...textPair}
      save: pair(pairKey: "save") {...textPair}      
      success: pair(pairKey: "success") {...textPair}
      legalDisclaimer: pair(pairKey: "subscribeLegalDisclaimer") {...textPair}
      marketingPreferencesCheckboxes: listFieldGroup(fieldKey: "marketingPreferencesCheckboxes") {
        ... on FieldOptionList { ...fieldOptionListValues }
        ... on SectionedFieldOptionList { ...sectionedFieldOptionListValues }
      }
    }
  }

  ${textPairFragment}
  ${fieldOptionListValueFragment}
  ${sectionedFieldOptionListValuesFragment}
`;

export const preloadPreferencesQuery = gql`
  query userEmailPreferences($email: String!) {
    preSelectedCheckboxes: userEmailPreferences(email: $email)
  }
`;

export const marketingEmailPrefsRequest = gql`
  mutation updateEmailPrefsRequest(
    $email: String!,
    $emailOptions: [BrandSelection]!,
    $originatingSection: String!,
  ) {
    updateEmailPrefsReq: updateEmailPrefsRequest(
      email: $email,
      emailOptions: $emailOptions,
      originatingSection: $originatingSection,
    ) {
      ...response
    }
  }

  ${apiResponseFragment}
`;
